import {
  CONTRACT_RENEWAL_STEPS,
  ContractRenewalStatusDto,
  ZONE_KEYS,
  HEALTHCHECK_NAMES,
} from 'domain/shared/newProject';
import { getHealthcheckByName } from '../../shared/healthcheck';
import { ControlData } from '../types';

export const getCommercialRequiredActionsHealthchecks = (data: ControlData) => {
  const healthChecks = data?.health?.healthChecks || [];

  const commercialStateHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.PROJECT_COMMERCIAL_STATE);
  const commercialStateStatusHealthcheck = getHealthcheckByName(
    healthChecks,
    HEALTHCHECK_NAMES.PROJECT_COMMERCIAL_STATE_STATUS,
  );
  const assumptionsHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.ASSUMPTIONS);
  const contractRenewalHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.CONTRACT_RENEWAL);
  const budgetStateHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.BUDGET_STATE);

  return {
    commercialStateHealthcheck,
    commercialStateStatusHealthcheck,
    assumptionsHealthcheck,
    contractRenewalHealthcheck,
    budgetStateHealthcheck,
  };
};

export const hasCommercialContractRenewalIssue = (
  healthchecks: ReturnType<typeof getCommercialRequiredActionsHealthchecks>,
) => {
  return !!(healthchecks.contractRenewalHealthcheck || healthchecks.budgetStateHealthcheck);
};

export const getContractRenewalMessage = (
  renewalStatus: ContractRenewalStatusDto | null,
  contractRenewalHealthcheck?: ReturnType<
    typeof getCommercialRequiredActionsHealthchecks
  >['contractRenewalHealthcheck'],
) => {
  if (contractRenewalHealthcheck?.targetZone === ZONE_KEYS.SAFE) {
    return null;
  }
  switch (renewalStatus?.step) {
    case CONTRACT_RENEWAL_STEPS.CREATE_OPPORTUNITY:
      return 'SOW is nearing its end. No renewal opportunity has been created.';
    case CONTRACT_RENEWAL_STEPS.SEND_PRESALE_REQUEST:
      return 'SOW is nearing its end. Presale request has not been sent.';
    case CONTRACT_RENEWAL_STEPS.INITIATE_WITHOUT_SOW:
      return 'SOW is nearing its end and new one is not signed yet.';
    default:
      return null;
  }
};

export const shouldShowCommercialRequiredActions = ({
  actionsCount,
  healthchecks,
}: {
  actionsCount: number;
  healthchecks: ReturnType<typeof getCommercialRequiredActionsHealthchecks>;
}) => {
  if (actionsCount === 0) {
    return false;
  }

  return Object.values(healthchecks).some(healthcheck => healthcheck?.targetZone !== ZONE_KEYS.SAFE);
};
